import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Alert } from '../shared/models/alert.model';
import { AlertSearch, CountAndResults } from '../shared/types';

@Injectable()
export class AlertService {
  private http = inject(HttpClient);


  get(id: string): Observable<Alert> {
    return this.http.get<Alert>(`/api/alert/${id}`);
  }

  add(alert: Alert): Observable<void> {
    return this.http.post<void>('/api/alert', alert);
  }

  search(body: AlertSearch): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/alerts/search', body);
  }

  update(alert: Alert): Observable<void> {
    return this.http.put<void>(`/api/alert/${alert._id}`, alert);
  }

  delete(alert: Alert): Observable<void> {
    return this.http.delete<void>(`/api/alert/${alert._id}`);
  }

}
